// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideMap as RawLucideMap } from "lucide-react";
export const LucideMap = /* @__PURE__ */ createIcon(RawLucideMap, "LucideMap", 2);
